import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import NewsletterSignup from "./NewsletterSignup";

const links = [
  ["/", "Overview"],
  ["/why-it-matters", "Why it matters"],
  ["/simulation", "Simulation"],
  ["/approach", "Approach"],
  ["/team", "Team"],
];

const nextRoutes = {
  "/": ["/why-it-matters", "Why it matters"],
  "/why-it-matters": ["/simulation", "Sampling simulation"],
  "/simulation": ["/approach", "Deployment and calibration"],
  "/approach": ["/team", "Meet the team"],
  "/team": ["/faq", "Questions and answers"],
  "/faq": ["/contact", "Contact Agroadvisor"],
};

export function Arrow() {
  return <span aria-hidden="true">↗</span>;
}

export default function Layout({ children }) {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const nextRoute = nextRoutes[location.pathname];

  useEffect(() => {
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <div className="site-shell">
      <header className="topbar">
        <NavLink className="brand" to="/" aria-label="Agroadvisor Birdwatcher home">
          <span className="brand-main">AGROADVISOR</span>
          <span className="brand-separator">/</span>
          <span className="brand-project">BIRDWATCHER</span>
        </NavLink>

        <button
          className="menu-toggle"
          type="button"
          aria-expanded={menuOpen}
          aria-label="Toggle navigation"
          onClick={() => setMenuOpen((value) => !value)}
        >
          <span />
          <span />
        </button>

        <nav className={`nav-links ${menuOpen ? "is-open" : ""}`} aria-label="Main navigation">
          {links.map(([to, label]) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              className={({ isActive }) => (isActive ? "active" : undefined)}
            >
              {label}
            </NavLink>
          ))}
          <Link className="mobile-contact" to="/contact">
            Contact <Arrow />
          </Link>
        </nav>

        <Link className="nav-cta" to="/contact">
          Contact <Arrow />
        </Link>
      </header>

      <main className="route-stage">{children}</main>

      {nextRoute && (
        <nav className="route-next" aria-label="Continue to next page">
          <span>Continue</span>
          <Link to={nextRoute[0]}>
            <strong>{nextRoute[1]}</strong>
            <span className="route-next-arrow" aria-hidden="true">→</span>
          </Link>
        </nav>
      )}

      <footer className="footer">
        <div className="footer-top">
          <div className="footer-brand">
            <span className="footer-brand-mark">AGROADVISOR / BIRDWATCHER</span>
            <p>Applied intelligence for real-world agriculture. Birdwatcher is our field measurement project for understanding poultry populations at operational scale.</p>
          </div>

          <div className="footer-columns">
            <div className="footer-column">
              <strong>Project</strong>
              <Link to="/why-it-matters">Why it matters</Link>
              <Link to="/simulation">Simulation</Link>
              <Link to="/approach">Approach</Link>
              <Link to="/team">Team</Link>
              <Link to="/faq">FAQ</Link>
            </div>
            <div className="footer-column">
              <strong>Company</strong>
              <Link to="/contact">Contact</Link>
              <Link to="/imprint">Imprint</Link>
              <Link to="/privacy">Privacy & data protection</Link>
              <Link to="/terms">Terms of use</Link>
            </div>
            <div className="footer-column">
              <strong>Direct</strong>
              <a href="tel:+36301634341">+36 30 163 4341</a>
              <a href="mailto:info@agroadvisor.hu?subject=Birdwatcher%20project%20enquiry">info@agroadvisor.hu</a>
              <span>3700 Kazincbarcika</span>
              <span>Rózsa út 57., Hungary</span>
            </div>
          </div>
        </div>

        <NewsletterSignup />

        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} Agroadviser Solutions Kft. · Birdwatcher project</span>
          <span>05-09-039444 · 32943805-2-05</span>
        </div>
      </footer>
    </div>
  );
}

